import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Guarantee.Guarantee_Full}
    mutation UpdateContractGuarantee(
        $id: ID!
        $contractId: ID!
        $guaranteeCategoryId: ID!
        $ceiling: String
        $deductible: String
        $guaranteeTargets: [GuaranteeTargetInput!]
    ) {
        updateGuarantee(
            input: {
                id: $id
                contractId: $contractId
                guaranteeCategoryId: $guaranteeCategoryId
                ceiling: $ceiling
                deductible: $deductible
                guaranteeTargets: $guaranteeTargets
            }
        ) {
            errors
            status
            statusCode
            guarantee {
                ...Guarantee_Full
            }
        }
    }
`
